import React, { createContext, useContext, useState, useCallback } from "react";

export const CONTACT = {
  whatsapp: "34612490485",
  phoneDisplay: "+34 612 490 485",
  email: "acerorefyco@gmail.com",
  city: "Córdoba, España",
};

export const translations = {
  es: {
    nav: { historia: "Historia", servicios: "Servicios", galeria: "Galería", opiniones: "Opiniones", contacto: "Contacto", cta: "Presupuesto gratis" },
    hero: {
      overline: "Construcción · Reformas · Excelencia",
      line1: "Construimos con experiencia.",
      line2: "Reformamos con excelencia.",
      sub: "Reformas integrales y obra nueva ejecutadas por un equipo cualificado. Acabados impecables, plazos cumplidos y un trato cercano en cada proyecto.",
      cta: "Solicita tu presupuesto gratuito",
      secondary: "Ver trabajos",
      scroll: "Desliza",
    },
    marquee: ["Reformas Integrales", "Obra Nueva", "Rehabilitación", "Acabados de Lujo", "Puntualidad", "Limpieza", "Trato Cercano", "Calidad Garantizada"],
    historia: {
      overline: "Nuestra Historia",
      title: "De un chico de 14 años a una empresa referente.",
      p1: "Hamilton comenzó a trabajar en la construcción con tan solo 14 años en Colombia. Durante años participó en la edificación de importantes proyectos para empresas reconocidas, adquiriendo un conocimiento profundo de todas las áreas del oficio.",
      p2: "Al llegar a España empezó realizando pequeñas reformas y trabajos particulares. Su compromiso, responsabilidad y la calidad impecable de sus acabados hicieron que cada cliente lo recomendara.",
      p3: "Con el paso de los años la empresa creció hasta ejecutar reformas integrales y obras de gran envergadura, contando hoy con un equipo de profesionales cualificados. Esfuerzo, pasión y excelencia en cada obra.",
      steps: [
        { year: "14 años", t: "Los inicios en Colombia", d: "Primeros pasos en la construcción, aprendiendo el oficio desde la base." },
        { year: "Grandes obras", t: "Proyectos de envergadura", d: "Participación en edificios y grandes proyectos para empresas reconocidas." },
        { year: "España", t: "Reformas y confianza", d: "Pequeñas reformas que, por su calidad, se convirtieron en recomendaciones constantes." },
        { year: "Hoy", t: "Empresa consolidada", d: "Reformas integrales y obra nueva con un equipo de profesionales cualificados." },
      ],
      stats: [
        { n: "25+", l: "Años de experiencia" },
        { n: "500+", l: "Proyectos entregados" },
        { n: "100%", l: "Clientes satisfechos" },
      ],
    },
    servicios: {
      overline: "Nuestros Servicios",
      title: "Todo lo que tu proyecto necesita, bajo un mismo equipo.",
      items: [
        { t: "Reformas integrales", d: "Transformamos por completo viviendas y locales de principio a fin." },
        { t: "Rehabilitación de edificios", d: "Devolvemos la vida y el valor a edificios y fachadas." },
        { t: "Albañilería", d: "Trabajos de albañilería profesional para cualquier proyecto." },
        { t: "Pladur", d: "Tabiques, techos y trasdosados con acabado perfecto." },
        { t: "Pintura", d: "Pintura interior y exterior con acabados limpios y duraderos." },
        { t: "Fontanería", d: "Instalaciones y reparaciones de fontanería fiables." },
        { t: "Alicatados y solados", d: "Colocación precisa de azulejos, gres y pavimentos." },
        { t: "Impermeabilizaciones", d: "Protección total contra humedades y filtraciones." },
        { t: "Cubiertas y tejados", d: "Reparación y construcción de cubiertas y tejados." },
        { t: "Mantenimiento", d: "Todo tipo de reformas y mantenimiento para tu propiedad." },
      ],
    },
    galeria: {
      overline: "Nuestros Trabajos",
      title: "Proyectos reales, acabados de verdad.",
      sub: "Fotos reales de reformas que hemos entregado en Córdoba y alrededores. Cada acabado, cuidado al detalle.",
      before: "Antes",
      after: "Después",
    },
    antes: {
      overline: "Antes y Después",
      title: "La transformación se ve.",
      sub: "Deslizador interactivo — arrastra para descubrir la transformación real de un techo en pladur ejecutado por nuestro equipo.",
      project: "Techo en pladur · Instalación completa",
    },
    testimonios: {
      overline: "Mensajes de clientes satisfechos",
      title: "Confianza construida cliente a cliente.",
      items: [
        { q: "Puntualidad y limpieza impecables. Dejaron mi piso como nuevo y siempre cumpliendo los plazos.", n: "María G.", r: "Reforma integral · Centro, Córdoba" },
        { q: "Profesionalidad de principio a fin. Hamilton vino personalmente a ver el proyecto y el presupuesto fue clarísimo.", n: "Javier R.", r: "Reforma de vivienda · Poniente, Córdoba" },
        { q: "El trato cercano marca la diferencia. Acabados de lujo y cero sorpresas en la factura final.", n: "Lucía M.", r: "Cocina y baños · Lucena" },
        { q: "Rehabilitaron la fachada de nuestro edificio con un resultado espectacular. Totalmente recomendables.", n: "Comunidad Vecinos", r: "Rehabilitación · Palma del Río" },
      ],
    },
    presupuestos: {
      overline: "Presupuestos personalizados",
      title: "Hamilton visita personalmente tu proyecto.",
      p: "Nada de presupuestos genéricos. Hamilton acude en persona a conocer tus necesidades y elaborar un presupuesto gratuito, detallado y sin compromiso, adaptado exactamente a lo que tu obra requiere.",
      points: ["Visita personal sin coste", "Presupuesto detallado y transparente", "Sin ningún compromiso"],
      cta: "Solicita tu presupuesto gratuito",
    },
    contacto: {
      overline: "Contacto",
      title: "Cuéntanos tu proyecto.",
      sub: "Rellena el formulario y te responderemos lo antes posible. También puedes escribirnos por WhatsApp.",
      name: "Nombre",
      phone: "Teléfono",
      email: "Correo electrónico",
      project: "Descripción del proyecto",
      projectPh: "Cuéntanos qué necesitas reformar o construir...",
      send: "Enviar solicitud",
      sending: "Enviando...",
      success: "¡Gracias! Hemos recibido tu solicitud. Te contactaremos muy pronto.",
      error: "No se pudo enviar. Inténtalo de nuevo o escríbenos por WhatsApp.",
    },
    footer: {
      tagline: "Construimos con experiencia. Reformamos con excelencia.",
      rights: "Todos los derechos reservados.",
      contact: "Contacto",
      services: "Servicios",
    },
    whatsappLabel: "Solicita tu presupuesto gratuito",
  },
  en: {
    nav: { historia: "Story", servicios: "Services", galeria: "Gallery", opiniones: "Reviews", contacto: "Contact", cta: "Free quote" },
    hero: {
      overline: "Construction · Renovation · Excellence",
      line1: "We build with experience.",
      line2: "We renovate with excellence.",
      sub: "Full renovations and new builds delivered by a qualified team. Flawless finishes, deadlines met, and a close, honest relationship on every project.",
      cta: "Request your free quote",
      secondary: "View work",
      scroll: "Scroll",
    },
    marquee: ["Full Renovations", "New Builds", "Rehabilitation", "Luxury Finishes", "Punctuality", "Cleanliness", "Personal Care", "Guaranteed Quality"],
    historia: {
      overline: "Our Story",
      title: "From a 14-year-old boy to a leading company.",
      p1: "Hamilton started working in construction at just 14 years old in Colombia. For years he took part in building major projects for renowned companies, gaining deep knowledge of every area of the trade.",
      p2: "When he arrived in Spain he began with small renovations and private jobs. His commitment, responsibility and the flawless quality of his finishes made every client recommend him.",
      p3: "Over the years the company grew to deliver full renovations and large-scale projects, today counting on a team of qualified professionals. Effort, passion and excellence in every build.",
      steps: [
        { year: "Age 14", t: "Beginnings in Colombia", d: "First steps in construction, learning the trade from the ground up." },
        { year: "Major works", t: "Large-scale projects", d: "Involved in buildings and big projects for renowned companies." },
        { year: "Spain", t: "Renovations & trust", d: "Small renovations that, thanks to their quality, turned into constant referrals." },
        { year: "Today", t: "An established company", d: "Full renovations and new builds with a team of qualified professionals." },
      ],
      stats: [
        { n: "25+", l: "Years of experience" },
        { n: "500+", l: "Projects delivered" },
        { n: "100%", l: "Satisfied clients" },
      ],
    },
    servicios: {
      overline: "Our Services",
      title: "Everything your project needs, under one team.",
      items: [
        { t: "Full renovations", d: "We completely transform homes and premises from start to finish." },
        { t: "Building rehabilitation", d: "We bring life and value back to buildings and façades." },
        { t: "Masonry", d: "Professional masonry work for any project." },
        { t: "Drywall", d: "Partitions, ceilings and linings with a perfect finish." },
        { t: "Painting", d: "Interior and exterior painting with clean, lasting finishes." },
        { t: "Plumbing", d: "Reliable plumbing installations and repairs." },
        { t: "Tiling & flooring", d: "Precise laying of tiles, stoneware and flooring." },
        { t: "Waterproofing", d: "Total protection against damp and leaks." },
        { t: "Roofing", d: "Repair and construction of roofs and coverings." },
        { t: "Maintenance", d: "All kinds of renovations and property maintenance." },
      ],
    },
    galeria: {
      overline: "Our Work",
      title: "Real projects, real finishes.",
      sub: "Real photos of renovations we've delivered in Córdoba and its region. Every detail carefully finished.",
      before: "Before",
      after: "After",
    },
    antes: {
      overline: "Before & After",
      title: "You can see the transformation.",
      sub: "Interactive slider — drag to reveal the real transformation of a drywall ceiling delivered by our team.",
      project: "Drywall ceiling · Complete installation",
    },
    testimonios: {
      overline: "Messages from satisfied clients",
      title: "Trust built one client at a time.",
      items: [
        { q: "Impeccable punctuality and cleanliness. They left my flat like new and always met the deadlines.", n: "María G.", r: "Full renovation · Centro, Córdoba" },
        { q: "Professionalism from start to finish. Hamilton came personally to see the project and the quote was crystal clear.", n: "Javier R.", r: "Home renovation · Poniente, Córdoba" },
        { q: "The personal care makes the difference. Luxury finishes and zero surprises on the final bill.", n: "Lucía M.", r: "Kitchen & baths · Lucena" },
        { q: "They rehabilitated our building's façade with a spectacular result. Highly recommended.", n: "Residents' Board", r: "Rehabilitation · Palma del Río" },
      ],
    },
    presupuestos: {
      overline: "Personalized quotes",
      title: "Hamilton personally visits your project.",
      p: "No generic quotes. Hamilton comes in person to understand your needs and prepare a free, detailed, no-obligation quote, tailored exactly to what your project requires.",
      points: ["Free personal visit", "Detailed, transparent quote", "No obligation whatsoever"],
      cta: "Request your free quote",
    },
    contacto: {
      overline: "Contact",
      title: "Tell us about your project.",
      sub: "Fill in the form and we'll get back to you as soon as possible. You can also reach us on WhatsApp.",
      name: "Name",
      phone: "Phone",
      email: "Email",
      project: "Project description",
      projectPh: "Tell us what you need to renovate or build...",
      send: "Send request",
      sending: "Sending...",
      success: "Thank you! We've received your request. We'll contact you very soon.",
      error: "Couldn't send. Please try again or reach us on WhatsApp.",
    },
    footer: {
      tagline: "We build with experience. We renovate with excellence.",
      rights: "All rights reserved.",
      contact: "Contact",
      services: "Services",
    },
    whatsappLabel: "Request your free quote",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("es");
  const toggle = useCallback(() => setLang((l) => (l === "es" ? "en" : "es")), []);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
